import React, { Component, useEffect, useState } from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper, Circle } from "google-maps-react";
import { refreshMapCordinates } from '../utility/apiService';
import { Button, Paper, Box } from "@material-ui/core";
import PuffLoader from "react-spinners/PuffLoader";
import { vodafoneFont, vodafoneColor } from "../api/data";
import { mapsErrorMessage } from "../../src/pages/dashboardError";
import { tealiumDataLayerPush } from "../utility/utility";

const customerIcon = require("../assets/img/customer-location.png");
const kunden = require("../assets/img/Kunden.svg");
const networkInterenetMid = require("../assets/img/network-internet-mid.svg");
const paperPenMid = require("../assets/img/paper-pen-mid.svg");

const MEAN_RADIUS_EARTH_IN_KM = 6378;
const ZOOM_FACTOR = 1.644;
interface mapProps {
  google: any;
  customerLocation: any;
  technicianLocation: any;
  technicianName: string;
  technicianPhone: string;
  technicianCompanyname: string;
  technicianImage: string;
  uid: string;
  eta: string;
  classes: any;
  street: any;
  houseNo: any;
  zip: any;
  city: any;
  country: any;
  anypointETA: string;
}

class MapView extends Component<mapProps, any> {
  // distanceMatrixStatus: string;
  // anyPointError = false;
  constructor(props) {
    super(props);
    this.state = {
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      mapLoaded: false,
      technicianLocation: this.props.technicianLocation,
      customerLocation: this.props.customerLocation,
      distanceToTravel: '',
      eta: '',
      distanceMatrixStatus: '',
      anyPointError: false,
      showMap: true,
      showEta: false,
      showCustomerDetails: false,
    };
    this.handleMapIdle = this.handleMapIdle.bind(this);
    this.onTechnicianMarkerClick = this.onTechnicianMarkerClick.bind(this);
    this.onCustomerMarkerClick = this.onCustomerMarkerClick.bind(this);
    this.calcMidPoint = this.calcMidPoint.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  refreshMap = () => {
    refreshMapCordinates(this.props.uid)
      .then((resp) => {
        if (resp['tripStarted'] && !resp['workStarted']) {
          this.calculateDistance({ lat: resp['seGpsLat'], lng: resp['seGpsLong'] });
        } else {
          this.setState({ showMap: false });
        }
      }).catch(err => {
        this.setState({ anyPointError: true });
        // this.anyPointError = true;
      })
  }

  onTechnicianMarkerClick = (props, marker, e) => {
    this.setState(prevState => ({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
      showEta: true,
      showCustomerDetails: false
    }));
  };

  onCustomerMarkerClick = (props, marker, e) => {
    this.setState(prevState => ({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
      showEta: false,
      showCustomerDetails: true
    }));
  };

  calcRadians(degree) {
    return degree * (Math.PI / 180);
  }

  calcDegrees(radian) {
    return radian * (180 / Math.PI);
  }

  calcMidPoint() {
    let lat1 = this.state.technicianLocation.lat;
    let lon1 = this.state.technicianLocation.lng;
    let lat2 = this.state.customerLocation.lat;
    let lon2 = this.state.customerLocation.lng;
    const dLon = this.calcRadians(lon2 - lon1);
    lat1 = this.calcRadians(lat1);
    lat2 = this.calcRadians(lat2);
    lon1 = this.calcRadians(lon1);
    const Bx = Math.cos(lat2) * Math.cos(dLon);
    const By = Math.cos(lat2) * Math.sin(dLon);
    const lat3 = Math.atan2(Math.sin(lat1) + Math.sin(lat2), Math.sqrt((Math.cos(lat1) + Bx) * (Math.cos(lat1) + Bx) + By * By));
    const lon3 = lon1 + Math.atan2(By, Math.cos(lat1) + Bx);
    const midLat = this.calcDegrees(lat3);
    const midLong = this.calcDegrees(lon3);
    return { lat: midLat, lng: midLong };
  }

  haversine(maxLat, minLat, maxLng, minLng) {
    const dLat = maxLat - minLat;
    const dLng = maxLng - minLng;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(minLat) * Math.cos(maxLat) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return (MEAN_RADIUS_EARTH_IN_KM * c);
  }

  optimalZoomLevel(maxLat, minLat, maxLng, minLng) {
    const minMapDimension = 180;
    maxLat = this.calcRadians(maxLat);
    minLat = this.calcRadians(minLat);
    maxLng = this.calcRadians(maxLng);
    minLng = this.calcRadians(minLng);
    const greatCircleDistance = this.haversine(maxLat, minLat, maxLng, minLng);
    const zoom = Math.floor(8 - Math.log(ZOOM_FACTOR * greatCircleDistance / Math.sqrt(2 * (minMapDimension * minMapDimension))) / Math.log(2));
    return zoom > 10 ? 10 : zoom;
  }

  onClose = () => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      });
    }
  };

  showMarkersCustomer = () => {
    return <Marker onClick={this.onCustomerMarkerClick} position={this.props.customerLocation}
      icon={{
        url: customerIcon, // url
        scaledSize: new google.maps.Size(30, 40),
      }}
    />
  }

  showCirclesCustomer = () => {
    return <Circle
      center={this.props.customerLocation}
      radius={0.1}
      fillColor={"#FF0000"}
      strokeColor={"#FF0000"}
    />
  }

  showMarkersTechnician = () => {
    return <Marker onClick={this.onTechnicianMarkerClick} position={this.state.technicianLocation}
      icon={{
        path: google.maps.SymbolPath.CIRCLE, // url
        scaledSize: new google.maps.Size(30, 50),
        fillColor: "red",
        fillOpacity: 1,
        strokeWeight: 16,
        strokeColor: "red",
        strokeOpacity: 0.2,
        scale: 8,
      }}
    />
  }

  showCirclesTechnician = () => {
    return <Circle
      center={this.props.technicianLocation}
      radius={0.1}
      fillColor={"#008000"}
      strokeColor={"#008000"}
    />
  }

  // calcDistance: any = () => {
  //     const distanceMatrixApi = "https://maps.googleapis.com/maps/api/distancematrix/json?" + 
  //     "origins=heading=90:37.773279,-122.468780&" +
  //     "destinations=37.773245,-122.469502&key=AIzaSyA7I3QU1khdOUoOwQm4xPhv2_jt_cwFSNU"
  //     axios.get(distanceMatrixApi, {headers:{'Access-Control-Allow-Origin':'*'}}).then(res => console.log(res));
  //   }

  handleMapIdle = () => {
    this.setState({
      mapLoaded: true
    });
  };

  calculateDistance(newTechnicianLocation: any = null) {
    new google.maps.DistanceMatrixService().getDistanceMatrix({
      origins: [new google.maps.LatLng(newTechnicianLocation?.lat || this.state.technicianLocation.lat, newTechnicianLocation?.lng || this.state.technicianLocation.lng)],
      destinations: [new google.maps.LatLng(this.state.customerLocation.lat, this.state.customerLocation.lng)],
      travelMode: google.maps.TravelMode.DRIVING,
    }, (response, status) => {
      if (status == 'OK') {
        this.setState({
          ...this.state,
          distanceToTravel: response.rows[0].elements[0].distance.text,
          eta: response.rows[0].elements[0].duration.value / 60,
          etaText: response.rows[0].elements[0].duration.text,
          technicianLocation: newTechnicianLocation || this.state.technicianLocation,
          distanceMatrixStatus: status
        });
      }
    });
  }

  checkGeodata = () => {
    const geoData = [this.state.customerLocation.lat, this.state.customerLocation.lng, this.state.technicianLocation.lat, this.state.technicianLocation.lng];
    if (geoData.indexOf(null) > -1) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    if (this.checkGeodata()) { this.calculateDistance() }
  }

  shouldComponentUpdate(prevState, nextState) {
    // if distance matrix status is not === OK do not refresh the map component
    return true;
  }

  render() {
    return (
      <div>
        { this.checkGeodata() && this.state.showMap
          && <div className={'map_map-view'}>
            <Map
              google={this.props.google}
              zoom={this.optimalZoomLevel(this.state.customerLocation.lat, this.state.technicianLocation.lat, this.state.customerLocation.lng, this.state.technicianLocation.lng)}
              onIdle={this.handleMapIdle}
              initialCenter={this.calcMidPoint()}//{this.state.initialCenter || this.state.customerLocation}
              fullscreenControl={false}
              streetViewControl={false}
              // mapTypeControl={window.innerWidth >= 768 ? true : false}
              className={'map-google-map'}
            >
              {this.showMarkersCustomer()}
              {this.showMarkersTechnician()}
              <InfoWindow
                marker={this.state.activeMarker}
                visible={this.state.showingInfoWindow}
                onClose={this.onClose}
              >
                {this.state.showEta && <div className="map_customer-details">Verbleibende Zeit: {this.state.etaText}</div>}
                {this.state.showCustomerDetails &&
                  <div>
                    <div className="map_customer-details">
                      {this.props.street}, {this.props.houseNo}
                    </div>
                    <div className="map_customer-details">
                      {this.props.zip}, {this.props.city}
                    </div>
                    <div className="map_customer-details">
                      {this.props.country}
                    </div>
                  </div>
                }
              </InfoWindow>
              <TechnicianOnWay />
            </Map>
            <InfoBox
              remainingTimeinMins={this.state.eta}
              remainingDistance={this.state.distanceToTravel}
              refreshMap={this.refreshMap}
              technicianName={this.props.technicianName}
              technicianPhone={this.props.technicianPhone}
              companyName={this.props.technicianCompanyname}
              technicianImage={this.props.technicianImage}
              anypointETA={this.props.anypointETA}
            />
          </div>}
        {(!this.checkGeodata() || this.state.distanceMatrixStatus !== "OK" || this.state.anyPointError) &&
          mapsErrorMessage(this.props.technicianCompanyname, this.props.technicianPhone,
            paperPenMid, networkInterenetMid, this.props.technicianName)}
      </div>
    );
  }
}

const LoadingContainer = (props: any) => (
  <div className={'swa-generic-flex-col'}>
    <div className={'swa-gen-flex-row gap2'} style={{ margin: 'auto' }}>
      <PuffLoader size={150} color={vodafoneColor} />
    </div>
    <text style={{ fontFamily: vodafoneFont, color: vodafoneColor, fontSize: "32", textAlign: 'center' }}>
      Einen moment, Standort des Technikers wird geladen.</text>
  </div>
)

export default GoogleApiWrapper((props) => ({
  LoadingContainer: LoadingContainer,
  url: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_CI_API_KEY}&quotaUser=${props.uid?.slice(0, 20)}`,
  region: 'de',
  language: 'de'
}))(MapView);

function InfoBox({ remainingTimeinMins, remainingDistance, refreshMap, technicianName,
  technicianPhone, companyName, technicianImage, anypointETA }) {
  const [buttonEnable, setButtonEnable] = useState(true);
  const disableFor30Sec = () => {
    refreshMap();
    setButtonEnable(false);
    setTimeout(() => { setButtonEnable(true) }, 30000);
    tealiumDataLayerPush('micro conversion', {}, {}, {}, {category:'google maps map',name:'update location'}).then();
  }

  const getEta = (remainingTimeinMins) => {
    let today = new Date();
    let d2 = new Date(today);
    d2.setMinutes(today.getMinutes() + remainingTimeinMins);
    let eta = d2.toLocaleTimeString('en-DE', { timeZone: 'Europe/Berlin' }).split(':')
    return eta[0] + ':' + eta[1];
  }
  return (
    <>
      <Paper elevation={5} variant={"outlined"} className={'map_info left bottom'} >
        <div className={"mapview-tech-bg-circle"}>
          <img className="map_tech-image" src={technicianImage || kunden}
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = kunden }} />
        </div>
        <Box className="swa-generic-flex-col">
          {technicianName && <h2 className={'swa-gen-margin-0'}>{technicianName}</h2>}
          <div>{remainingDistance} entfernt - Ankunft ca.  {getEta(remainingTimeinMins)} Uhr</div>
          <div className={'swa-gen-flex-row gap2 center'}>
            <div className={'swa-gen-flex-row gap1'}>
              <img className="map_icon" src={paperPenMid} />
              <div className="map_text">{companyName}</div>
            </div>
            <div className={'swa-gen-flex-row gap1'}>
              <img className="map_icon" src={networkInterenetMid} />
              <div className="map_phone-text">{technicianPhone}</div>
            </div>
          </div>
          <Button
            variant="contained"
            className={buttonEnable ? 'button-enabled' : 'button-disabled'}
            onClick={disableFor30Sec}
            disabled={!buttonEnable}>Aktualisieren</Button>
          {!buttonEnable ? <ShowTimer /> : null}
        </Box>
      </Paper>
    </>
  )
}

function ShowTimer() {
  const [seconds, setSeconds] = React.useState(30);

  React.useEffect(() => {
    let mounted = true;
    if (seconds > 0) {
      setTimeout(() => mounted && setSeconds(seconds - 1), 1000);
    } else {
      setSeconds(30);
    }
    return function cleanUp() {
      mounted = false;
    }
  });

  return (
    <div className={'text-center'}>
      <div>
        {seconds} Sekunden bis zum nächsten Versuch
      </div>
    </div>
  );
}

function TechnicianOnWay() {
  return (
    <div className={'absolute block translucent top block-center'}>
      Dein Techniker ist auf dem Weg zu dir.
    </div>
  )
}